import { resolveTranslationKey } from './whatsappMessageWithButtonsKeyResolver';

export function WhatsappMessageWithButtonsButtonViewConstructor(services, callbacks, context, siteTypeConfig) {

    let joint = services.joint;
    return joint.shapes.html.AbstractElementView.extend({
        isElementEditable: true,
        isElementDeletable: true,
        editElementModalController: 'editWhatsappMessageWithButtonsButtonController',
        editElementModalTemplate: require('./editWhatsappMessageWithButtonsButton.modal.html'),
        angularTemplate: `
    <div layout="row" class="alc-ellipsis">
        {{elementData.title || elementView.resolveTranslationKey('button_title_placeholder') | translate}}
    </div>
`,
  resolveTranslationKey: function (key) {
    return resolveTranslationKey(this.getParentType(), key);
  },

  removeElement: function () {
    // don't removeElement if parent has only 2 children, which are UserInput and 1 button
    // WhatsappMessagWithButtons must have at least 1 button
    const parent = this.model.getAncestors()[0];
    if (parent.attributes.embeds.length > 2) {
      this.model.remove(); // the serialized graph will be updated by a global handler for the 'remove' event on the graph
      this.paper.findViewByModel(parent).resizeBox();
    }
  }

  });
}